import { useContext, useEffect, useMemo, useReducer, useState } from 'react'

import HomeIcon from '@/public/icons/home_line.svg'
import InvisibleIcon from '@/public/svg/invisible.svg'
import {
  Breadcrumbs,
  Container,
  Heading,
  // Heading,
  ShareContainer,
  ShareDrawer,
  theme,
  useHealthToolsCache,
} from '@hhgtech/hhg-components'
import { Text, Button } from '@hhgtech/hhg-components/mantine'
// import classNames from 'classnames'
import classNames from 'classnames'
import { Icons } from 'components/atoms/icons'
import { TwoColumnsContainer } from 'components/molecules'
import { AdBlock } from 'components/molecules/adBlock'
import { FixedBottomAdBlock } from 'components/molecules/adBlock/fixedBottomAdBlock'
import { ToolsSuggestionArticles } from 'components/molecules/toolsSuggestionArticles'
import { VideoList } from 'components/organisms/videoLists'
import { OvulationInfo } from 'components/templates/ovulationCalculator/ovulationInfo'
import { domainLocales } from 'domainLocales'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { HEALTH_TOOL_TYPE, basePath } from 'interfaces/constants'
import { BabyPoopPage } from 'interfaces/types'
import { useIntl } from 'react-intl'
import { AppContext } from 'state/appContext'
import { getAdTag, getCountryAdTag, getLocaleCategoryAdTag } from 'utils/ads'

// import { StyledSuggestedArticlesContainer } from '../../index.styled'
import { StyledSuggestedArticlesContainer } from '../../index.styled'
import { BabyPoopHeader } from '../components'
import {
  StyledBabyPoopInfo,
  StyledBabyPoopInnerContent,
  StyledBabyPoopSignatureColorBar,
} from '../components/index.styled'
import { colorMap } from '../helpers'
import {
  StyledActions,
  StyledBabyPoopDetail,
  StyledBabyPoopDetailImageFloatContent,
  StyledBabyPoopDetailImageWrapper,
  StyledBabyPoopDetailMainColumn,
  StyledBabyPoopDetailPoopImage,
  StyledBody,
  StyledBreadCrumbsContainer,
  StyledContent,
  StyledDisclamerInfo,
  StyledMobileShare,
} from './index.styled'

export type Props = {
  babyPoopPage: BabyPoopPage
}

const BabyPoopDetail = ({ babyPoopPage }: Props) => {
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()

  const {
    locale,
    asPath,
    router: { query, replace, push },
  } = useRouterExtend()
  const { getHealthToolLink } = useHealthToolsCache(locale + '_MB')
  const { pushNotifications } = useContext(AppContext)
  const currentUrl = useCurrentUrl()

  const [isShareOpen, setIsShareOpen] = useState(false)
  const [isBlurred, toggleIsBlurred] = useReducer((b) => !b, true)
  const adUnitPath = getAdTag({
    countryAdTag: getCountryAdTag(locale, {
      isMobile,
    }),
    contentAdTag: getLocaleCategoryAdTag(locale, asPath) || {
      result: 'HealthTools',
      redundant: true,
    },
  })

  const item = useMemo<
    BabyPoopPage['result'][number] | undefined | null
  >(() => {
    if (!query.type) {
      return null
    }

    return babyPoopPage.result.find(
      (poop) =>
        poop.name === query.type ||
        poop.name === decodeURI(String(query.type)) ||
        null,
    )
  }, [query.type])

  useEffect(() => {
    if (!item) {
      replace(getHealthToolLink(HEALTH_TOOL_TYPE.BABY_POOP))
      return
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [item])

  if (!item) {
    return null
  }

  const onShare = () => {
    if (isMobile) {
      setIsShareOpen(true)
    }
  }

  const onCopied = () => {
    pushNotifications({
      type: 'success',
      title: 'Success',
      message: f({
        id: 'common.copySuccess',
        defaultMessage: 'Link copied successfully',
      }),
    })
  }

  return (
    <>
      {isMobile && (
        <ShareDrawer
          locale={locale}
          url={currentUrl}
          open={isShareOpen}
          onClose={() => setIsShareOpen(false)}
          onCopied={onCopied}
          onShared={() => setIsShareOpen(false)}
        />
      )}
      <StyledBabyPoopDetail>
        <StyledBreadCrumbsContainer className="lightpink">
          <Container>
            <Breadcrumbs
              size="sm"
              className="breadcrumbs"
              pages={[
                {
                  label: <HomeIcon />,
                  value: '/',
                  dataEventCategory: 'Breadcrumb',
                  dataEventAction: 'Click',
                  dataEventLabel: `https://${domainLocales[locale]}`,
                },
                {
                  label: f({ id: 'healthtools.title' }),
                  value: `https://${domainLocales['vi-VN']}${basePath}/health-tools`,
                  dataEventCategory: 'Breadcrumb',
                  dataEventAction: 'Click',
                  dataEventLabel: `https://${domainLocales['vi-VN']}${basePath}/health-tools`,
                },
                {
                  label: babyPoopPage?.title || '',
                  active: true,
                  value: '#',
                  dataEventCategory: 'Breadcrumb',
                },
              ]}
            />
          </Container>
        </StyledBreadCrumbsContainer>

        {babyPoopPage.sponsorBanner?.showSponsorBanner && (
          <BabyPoopHeader
            style={{ marginTop: 0 }}
            babyPoopPage={babyPoopPage}
          />
        )}

        <Container style={{ padding: '0 16px 16px 16px' }}>
          <TwoColumnsContainer
            isHavingBorder={false}
            // leftStyle={{ paddingRight: 16, width: '63%' }}
            leftColumn={
              <StyledBabyPoopDetailMainColumn>
                <StyledBabyPoopDetailImageWrapper data-is-blurred={isBlurred}>
                  <StyledBabyPoopDetailPoopImage
                    src={item.image}
                    alt={item.titleResult}
                  />

                  <StyledBabyPoopDetailImageFloatContent>
                    <InvisibleIcon />

                    <div>
                      <Text
                        size="s3"
                        weight="semiBold"
                        color={theme.colors.white}
                      >
                        {f({
                          id: 'babyPoop.contentWarningMessage',
                          defaultMessage: 'Warning content: Sensitive content',
                        })}
                      </Text>
                      <Text
                        size="p4"
                        color={theme.colors.white}
                        className="mt-16"
                      >
                        {f({
                          id: 'babyPoop.contentWarningDescription',
                          defaultMessage: `This image may be sensitive`,
                        })}
                      </Text>

                      <Button
                        size="md"
                        onClick={toggleIsBlurred}
                        className="mt-16"
                      >
                        {f({
                          id: isBlurred
                            ? 'babyPoop.image.unblur'
                            : 'babyPoop.image.blur',
                          defaultMessage: isBlurred ? 'Show' : 'Blur',
                        })}
                      </Button>
                    </div>
                  </StyledBabyPoopDetailImageFloatContent>
                </StyledBabyPoopDetailImageWrapper>

                <StyledBabyPoopSignatureColorBar
                  signatureColor={colorMap[item.color].displayColor}
                  width={168}
                  className="mt-16"
                />
                <StyledBody>
                  <StyledContent>
                    <Text size="s1" weight="semiBold" className="mt-16">
                      {item.titleResult}
                    </Text>
                    <Text size="p4" className="mt-4">
                      {item.textInput}
                    </Text>

                    <Text size="s2" weight="semiBold" className="mt-24">
                      {f({
                        id: 'babyPoop.describle',
                        defaultMessage: 'Describle',
                      })}
                    </Text>
                    <Text as="div">
                      <StyledBabyPoopInnerContent
                        className="mt-8"
                        dangerouslySetInnerHTML={{
                          __html: item.description,
                        }}
                      />
                    </Text>

                    <Text size="s2" weight="semiBold" className="mt-24">
                      {f({
                        id: 'babyPoop.whatShouldDo',
                        defaultMessage: 'What should I do?',
                      })}
                    </Text>
                    <Text as="div">
                      <StyledBabyPoopInnerContent
                        className="mt-8"
                        dangerouslySetInnerHTML={{
                          __html: item.whatShouldIDo,
                        }}
                      />
                    </Text>
                  </StyledContent>

                  {isMobile ? (
                    <StyledMobileShare>
                      <Button
                        size="lg"
                        variant="tertiary"
                        className="share"
                        data-event-category="Health Tool"
                        data-event-action="Baby Growth Result Share"
                        data-event-label={currentUrl}
                        rightIcon={<Icons.Share size={18} />}
                        onClick={onShare}
                        styles={{
                          root: {
                            padding: '0 16px',
                            width: '48px',
                          },
                          inner: {
                            '.mantine-Button-icon': {
                              marginLeft: 0,
                            },
                          },
                        }}
                      />
                      <Button
                        variant="secondary"
                        size="lg"
                        onClick={() =>
                          push(
                            `${
                              window.location.origin
                            }${basePath}${getHealthToolLink(
                              HEALTH_TOOL_TYPE.BABY_POOP,
                            )}`,
                          )
                        }
                        style={{
                          flexGrow: 1,
                        }}
                      >
                        {f({
                          id: 'riskScreener.back',
                          defaultMessage: 'Back',
                        })}
                      </Button>
                    </StyledMobileShare>
                  ) : (
                    <StyledActions>
                      <ShareContainer
                        url={currentUrl}
                        onCopied={onCopied}
                        locale={locale}
                      />
                      <Button
                        variant="secondary"
                        size="lg"
                        // className={classNames(
                        //   'mx-a',
                        //   isMobile ? 'mt-24' : 'mt-40',
                        // )}
                        style={{ minWidth: '260px', width: 'auto' }}
                        onClick={() =>
                          push(
                            `${
                              window.location.origin
                            }${basePath}${getHealthToolLink(
                              HEALTH_TOOL_TYPE.BABY_POOP,
                            )}`,
                          )
                        }
                      >
                        {f({
                          id: 'riskScreener.back',
                          defaultMessage: 'Back',
                        })}
                      </Button>
                    </StyledActions>
                  )}
                  <VideoList
                    title={f({
                      id: 'babyPoop.video.title',
                      defaultMessage: 'Làm Mẹ nhẹ tênh, chẳng lo bé Táo Bón',
                    })}
                    videos={babyPoopPage.sponsorBanner?.videoBlock?.listVideo}
                  />
                  <StyledDisclamerInfo>
                    {babyPoopPage.disclaimer && (
                      <OvulationInfo
                        heading={f({ id: 'ovulationPage.disclaimer' })}
                        content={babyPoopPage.disclaimer}
                        // className="mt-24"
                      />
                    )}

                    {!!item.faqs.length && (
                      <StyledBabyPoopInfo
                        // className="faqs-block"
                        heading={f({ id: 'tools.faqs' })}
                        infos={item.faqs}
                        withDisclaimer={!!babyPoopPage.disclaimer}
                      />
                    )}
                  </StyledDisclamerInfo>
                </StyledBody>
                {isMobile && (
                  <>
                    <div
                      className="top-ad my-16"
                      style={{
                        minHeight: 250,
                      }}
                    >
                      <AdBlock
                        adUnitPath={adUnitPath}
                        size={[
                          [300, 250],
                          [300, 600],
                        ]}
                        divId={'div-gpt-ad-midbanner1-mobile'}
                        pos={['MidBanner1']}
                      />
                    </div>

                    {!!item.recommendArticles?.length && (
                      <StyledSuggestedArticlesContainer
                        className={classNames({
                          '-mx-16': isMobile,
                        })}
                      >
                        <Heading
                          tag="h3"
                          color={theme.colors.gray800}
                          style={{ width: '100%', padding: '8px 16px' }}
                        >
                          {f({
                            id: 'tools.suggestedArticles',
                            defaultMessage: 'Suggested articles',
                          })}
                        </Heading>
                        <ToolsSuggestionArticles
                          isMobile
                          expertsArticles={item.recommendArticles}
                          hideUIElements
                        />
                      </StyledSuggestedArticlesContainer>
                    )}
                  </>
                )}
              </StyledBabyPoopDetailMainColumn>
            }
            rightColumn={
              !isMobile ? (
                <div className="pl-16">
                  <div
                    className="top-ad"
                    style={{
                      minHeight: 250,
                    }}
                  >
                    <AdBlock
                      adUnitPath={adUnitPath}
                      size={[
                        [300, 250],
                        [300, 600],
                      ]}
                      divId={'div-gpt-ad-midbanner1-desktop'}
                      pos={['MidBanner1']}
                    />
                  </div>

                  {!!item.recommendArticles?.length && (
                    <StyledSuggestedArticlesContainer>
                      <Heading
                        tag="h4"
                        color={theme.colors.gray800}
                        style={{
                          width: '100%',
                          padding: '8px 16px',
                          marginBottom: '9px',
                        }}
                      >
                        {f({
                          id: 'tools.suggestedArticles',
                          defaultMessage: 'Suggested articles',
                        })}
                      </Heading>
                      <ToolsSuggestionArticles
                        isMobile
                        expertsArticles={item.recommendArticles}
                        hideUIElements
                      />
                    </StyledSuggestedArticlesContainer>
                  )}
                </div>
              ) : undefined
            }
          />
        </Container>
        <FixedBottomAdBlock
          adUnitPath={adUnitPath}
          className="article-bottom-ad"
          isMobile={isMobile}
        />
      </StyledBabyPoopDetail>
    </>
  )
}

export { BabyPoopDetail }
